import React from 'react';
import { Route } from 'react-router';

import { LoadableApp } from '@/routes/routes/helpers/loadables';

import AuthRoutes from './routes/Auth';
import CatchAllRoutes from './routes/CatchAll';
import ChallengeAwardsRoutes from './routes/ChallengeAwards';
import GroupChallengesRoutes from './routes/GroupChallenges';
import LabsRoutes from './routes/Labs';
import HealthCheckRoutes from './routes/HealthCheck';
import MiscellaneousRoutes from './routes/Miscellaneous';
import StaticPagesRoutes from './routes/StaticPages';
import StripeRoutes from './routes/Stripe';
import SuggestionConfirmation from './routes/SuggestionConfirmation';

// Route configuration
// Read more https://github.com/ReactTraining/react-router/tree/v3.2.1/docs
const routes = (authService) => {
  return (
    <Route path="/" component={LoadableApp}>
      {/* Static pages */}
      {StaticPagesRoutes}

      {/* Healthcheck */}
      {HealthCheckRoutes}

      {/* Labs */}
      {LabsRoutes}

      {/* SuggestionConfirmation route */}
      {SuggestionConfirmation}

      {/* Auth */}
      {AuthRoutes}

      {/* Stripe Connect Accounts */}
      {StripeRoutes}

      {/* Challenge Awards  */}
      {ChallengeAwardsRoutes}

      {/* Group Challenges Invite Fallback Route */}
      {GroupChallengesRoutes}

      {/* Miscellaneous */}
      {MiscellaneousRoutes(authService)}
      {/* WARNING: Do not add new routes below the MiscellaneousRoutes above.
        They will catch most routes and throw a 404 if we don't
        have a category page for them */}
      {CatchAllRoutes}
    </Route>
  );
};

// Export routes to be shared by both client and server-side
export default routes;
